import { Injectable } from '@angular/core';

@Injectable()
export class AirportOperations {
    itnAirCarrier: boolean;
    itnAirTaxi: boolean;
    itnGa: boolean;
    itnMil: boolean;
    localGa: boolean;
    localMil: boolean;
    totalOverflights: boolean;
    ifrItnAc: boolean;
    ifrItnAt: boolean;
    ifrItnGa: boolean;
    ifrItnMi: boolean;
}


/** WEBPACK FOOTER **
 ** ./app/scenario-activities/airport-operations.ts
 **/